"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var change_emitter_1 = require("@findify/change-emitter");
var storage_1 = require("./modules/storage");
var request_1 = require("./modules/request");
var helpers_1 = require("./utils/helpers");
var settings_1 = require("./settings");
__export(require("./types"));
var types_1 = require("./types");
var emitter = change_emitter_1.createChangeEmitter();
var state = {
    events: {},
    filters: {}
};
var getUser = function () { return ({
    uid: storage_1.default.uid,
    sid: storage_1.default.sid,
    persist: storage_1.default.persist,
    exist: storage_1.default.exist,
}); };
var sendEventCreator = function (_a) {
    var events = _a.events, key = _a.key;
    return function (event, _request, useCookie, endpoint) {
        if (_request === void 0) { _request = {}; }
        var force = _request.force, request = __rest(_request, ["force"]);
        if (!force && typeof events[event] !== 'undefined' && events[event] === false)
            return;
        if (useCookie)
            return storage_1.default.memoize(event, request);
        var properties = event === types_1.EventName.viewPage
            ? __assign({}, request, { url: window.location.href, ref: window.document.referrer, width: window.screen.width, height: window.screen.height }) : request;
        emitter.emit(event, properties);
        return request_1.request({ key: key, event: event, properties: properties, user: getUser() }, endpoint);
    };
};
var createInvalidator = function (sendEvent, _a) {
    var platform = _a.platform, events = _a.events;
    return function (eventsToFire) {
        if (!Object.keys(eventsToFire).length)
            return;
        state.events = __assign({}, state.events, eventsToFire);
        return Object.keys(eventsToFire).forEach(function (key) {
            var endpoint;
            if (events[key] === false)
                return;
            if (key === types_1.EventName.updateCart) {
                if (helpers_1.shallowEqual(eventsToFire[key], storage_1.default.cart))
                    return;
                storage_1.default.cart = state.events[key];
            }
            if (key === types_1.EventName.purchase && platform.bigcommerce) {
                endpoint = settings_1.default.bigcommerceTrackingUrl;
            }
            return sendEvent(key, eventsToFire[key], false, endpoint);
        });
    };
};
exports.default = (function (props) {
    if (helpers_1.isFunction(props))
        return emitter.listen(props);
    var config = __assign({ events: {}, platform: {} }, props);
    var sendEvent = sendEventCreator(config);
    var invalidate = createInvalidator(sendEvent, config);
    invalidate(storage_1.default.memorized);
    return {
        sendEvent: sendEvent,
        invalidate: invalidate,
        listen: emitter.listen,
        get user() { return getUser(); },
        get state() { return state; },
        set state(s) { state = s; }
    };
});
//# sourceMappingURL=index.js.map